import React, { useEffect, useRef, useState } from 'react';
import { Table, Input, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import download from '../../../assets/V2-images/download.png';
import {
  Changeassetstatus,
  DeleteDraftAssetURL,
  DeleteDraftTransURL,
  EditAssetDetailsURL,
  GetShareUrl,
  Sharedata,
  editCollectionAssetsURL,
} from './../DAM_API/urls.js';
import Axios, { header } from 'functions/Axios';
import SpinnerLoader from '../../SpinnerLoader';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import close from '../../../assets/V2-images/close.svg';
import addcomponent from '../../../assets/V2-images/addcomponent.svg';
import copyurlicon from '../../../assets/V2-images/copyurlicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import shareicon from '../../../assets/V2-images/shareicon.png';
import { Deletemodel } from 'Common/Deletemodel';
import { ButtonC } from 'Common/Buttons';
import InputC from 'Common/Inputs/index.tsx';
import moment from 'moment';
import { DAM_SVG } from '../DamAssets';
import { setOpenPopup } from 'actions/damActions';
import { useDispatch } from 'react-redux';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import WordWrapEllipse from '../WordWrapEllipse';
import CommonThreeDotSvg from '../Components/CommonThreeDotSvg';
import { useDownloadAssets } from 'context/DownloadAssetsContext.jsx';
const getUserTimezone = () => {
  const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date();
  const offset = -date.getTimezoneOffset() / 60; // Convert minutes to hours
  const isdst = new Date().getMonth() > 2 && new Date().getMonth() < 10; // Approximation for DST
  const abbr = systemTimezone.split('/').pop(); // Simple abbreviation from timezone name

  return {
    value: systemTimezone,
    label: `(UTC${offset >= 0 ? `+${offset}` : offset}:00) ${systemTimezone}`,
    offset: offset,
    abbrev: abbr,
    altName: systemTimezone,
  };
};
const Tabledata = ({
  assets,
  setAssets,
  FolderselectAsset,
  show,
  datashow,
  IsInside = true,
  FromCollection = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [allAssetsSelected, setAllAssetsSelected] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [modal, setmodal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showbar, setshowbar] = useState(false);
  const [isExpiration, setIsExpiration] = useState(false);
  const [error, setError] = useState({});
  const [userTimeZone, setUserTimeZone] = useState(getUserTimezone());

  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [datapass, setdatapass] = useState();
  const [addcollection, setaddcollection] = useState(false);
  const [datacollection, setDatacollection] = useState();
  const [sharelink, setsharelink] = useState(false);
  const [linkdata, setlinkdata] = useState();
  const [expiredate, setexpiredate] = useState();
  const [expitetime, setexpitetime] = useState();
  const [shareshow, setshareshow] = useState(false);
  const [indexdata, setindexdata] = useState();
  const [triggerComponenet, setTriggerComponent] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [activeId, setActiveId] = useState();
  const dispatch = useDispatch();
  const threedotIconRef = useRef();
  const clickedIconRef = useRef(false);
  const { startDownload } = useDownloadAssets();

  const deletmodal = () => {
    setmodal(true);
  };

  const handledelette = async (e) => {
    try {
      setDeleteLoading(true);
      const formData = new FormData();
      formData.append('damIds_list', selectedDamFieldId);
      const _data = {
        damIds_list: [selectedDamFieldId],
      };

      setTimeout(() => {
        setmodal(false);
      }, 4000);
      const data = await Axios.delete(DeleteDraftAssetURL, { data: _data });
      setAddToCollectionModal(false);
      setDeleteLoading(false);
      setmodal(false);
      toast.success(data?.data?.message);
      datashow();
    } catch (err) {
      setDeleteLoading(false);
      console.error(err);
    }
  };

  const closeBtn1 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('damFileId', selectedDamFieldId);
      formData.append('assetName', textvalue);

      const response = await Axios.post(EditAssetDetailsURL, formData);
      if (response.data.success) {
        datashow();
        setAddToCollectionModal(false);
        toast.success(response?.data?.message ?? 'Edit Successfully'); // Moved toast.success here
      } else {
        // Handle error case
        toast.error('Edit Failed'); // Moved toast.error here
      }
    } catch (error) {
      // Handle error
      toast.error('Edit Failed'); // Moved toast.error here
    } finally {
      setAddToCollectionModal(false);
      setshowbar(false);
    }
  };

  const collectiondataadd = (damFileId) => {
    setdatapass(damFileId);
    setaddcollection(true);
  };
  const handleCollectionClick = async (collectionID) => {
    try {
      const formData = new FormData();
      formData.append('collectionID', collectionID);
      formData.append('damIds_list', datapass);

      const response = await Axios.post(editCollectionAssetsURL, formData);

      if (response.data.success) {
        fetchCollection();
        toast.success(response.data.message ?? 'Add Collection Successful');
      } else {
        // Handle error case
      }
    } catch (error) {
      toast.error('Add Collection Failed');
    } finally {
      setaddcollection(false);
      setshowbar(false);
    }
  };
  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setaddcollection(false)}
      style={{ cursor: 'pointer' }}
    />
  );
  const fetchCollection = async () => {
    try {
      // const response = await Axios.get(ListofCollectionsURL);
      // if (!response.data.errorStatus) {
      //   setDatacollection(response?.data?.data);
      // } else {
      //   // Handle error
      // }
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchCollection();
  }, []);

  const Copylink = (damFileId, url) => {
    if (url) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setsharelink(false);
          toast.success('Copied Successfully '); // Moved toast.success here
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
          toast.error('Copy Failed'); // Moved toast.error here
        });
      return;
    }
    const selectedItem = assets?.find(
      (item) => item.damFileId && (item.damFileId === damFileId || item.clientId === damFileId),
    );
    if (selectedItem && selectedItem.fileUrl) {
      const fileUrl = selectedItem.fileUrl;

      navigator.clipboard
        .writeText(fileUrl)
        .then(() => {
          setsharelink(false);
          toast.success('Copied Successfully '); // Moved toast.success here
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
          toast.error('Copy Failed'); // Moved toast.error here
        });
    } else {
      console.error('Selected item not found or missing fileUrl property.');
    }
    setshowbar(false);
  };

  const handleshowdata = async (damFileId, index) => {
    setindexdata(index);
    setsharelink(!sharelink);
    try {
      const response = await Axios.get(GetShareUrl + damFileId);
      setlinkdata(response?.data?.data);
    } catch (error) {
      console.error('Error fetching the share URL:', error);
    }
    // setshareshow(!shareshow);
  };
  const updateError = (name, value) => {
    setError((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormValidation = () => {
    let formIsValid = true;
    if (isExpiration) return formIsValid;
    if (!expiredate?.startDate) {
      updateError('startDate', 'Please Enter Start Date');
      formIsValid = false;
    }
    if (!expitetime?.startTime) {
      updateError('startTime', 'Please Enter  Start Time');
      formIsValid = false;
    }
    if (!userTimeZone?.value) {
      updateError('userTimeZone', 'Please Enter TimeZone');
      formIsValid = false;
    }
    if (!expiredate?.licenseExpiry) {
      updateError('licenseExpiry', 'Please Enter License Expiry');
      formIsValid = false;
    }

    if (!expitetime?.timeexpiry) {
      updateError('timeexpiry', 'Please Enter Time Expiry');
      formIsValid = false;
    }

    return formIsValid;
  };
  const handleDateChange = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD'); // Use the format 'YYYY-MM-DD' for date input
    setexpiredate((prevItems) => ({
      ...prevItems,
      licenseExpiry: formattedDate,
    }));
  };

  const handletimechanger = (time) => {
    const formettime = moment(time, 'HH:mm').format('HH:mm:ss');
    setexpitetime((prevItem) => ({
      ...prevItem,
      timeexpiry: formettime,
    }));
  };

  const closeBtn5 = (
    <img
      src={close}
      alt="closeicon"
      className="close"
      onClick={() => setsharelink(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const toggleShareLink = () => {
    setsharelink(!sharelink);
  };

  const onViewClickHandler = (damFileId) => {
    navigate('/dam/dam-asset-information_v2', { state: { props: damFileId } });
  };

  const SelectAll = () => {
    if (IsInside) {
      setAssets((prev) => ({
        ...prev,
        files: assets.map((item) => {
          return { ...item, selected: !allAssetsSelected };
        }),
      }));
    } else {
      setAssets(
        assets.map((item) => {
          return { ...item, selected: !allAssetsSelected };
        }),
      );
    }

    setAllAssetsSelected(!allAssetsSelected);
  };

  const selectAsset = (index) => {
    setTriggerComponent(!triggerComponenet);
    if (FolderselectAsset) {
      FolderselectAsset(index);
      return;
    }

    let newAssets = assets;
    newAssets[index].selected = !assets[index].selected;
    if (IsInside) {
      setAssets((prev) => ({
        ...prev,
        files: newAssets,
      }));
    } else {
      setAssets(newAssets);
    }
  };

  const onDeleteHandler = async (damFileId) => {
    setIsLoading(true);
    try {
      const { data } = await Axios.delete(
        DeleteDraftTransURL,
        { data: { FilesID: [damFileId] } },
        header,
      );
      if (!data.errorStatus) {
        let arr = assets.filter((item) => item.damFileId !== damFileId);
        setAssets(arr);
      } else {
        // alert('Something went wrong');
      }
    } catch (error) { }
    setIsLoading(false);
  };

  const toggle = () => setmodal(!modal);

  const showImage = (image) => {
    toggle();
    setImagePreview(image);
  };

  const downloadImages = async (value_id) => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.damFileId);


      await startDownload({
        fileId: selectedDamFileIds?.length > 0 ? selectedDamFieldId : [value_id],
        folderId: [],
      })


    } catch (error) {
      console.error('Error downloading the files:', error);
      // toast.error('Download Failed');
    }
  };

  const delteMultipleDraft = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.assetId);

      const _data = {
        damIds_list: selectedDamFileIds,
      };
      const data = await Axios.delete(DeleteDraftAssetURL, {
        data: _data, // Put your payload inside the `data` key
      });
      toast.success(data?.data?.message);
      datashow();
    } catch (err) {
      console.error(err);
    }
  };

  const Addassits = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.assetId);

      const formData = new FormData();
      selectedDamFileIds.forEach((id) => formData.append('damIds_list', id));
      const body = {
        damIds_list: selectedDamFileIds?.map((item) => `${item}`),
      };

      const response = await Axios.post(Changeassetstatus, body);

      if (response.data.success) {
        toast.success(response?.data?.message ?? 'Added Successfully');
        const remainingImages = assets.filter((asset) => !asset.selected);
        if (IsInside) {
          setAssets((prev) => ({
            ...prev,
            files: assets.filter((asset) => !asset.selected),
          }));
        } else {
          setAssets(assets.filter((asset) => !asset.selected));
        }
        datashow();

        setAllAssetsSelected(false);
      } else {
        console.error('Error adding assets:', response.data.message);
        toast.error('Add Failed');
      }
    } catch (error) {
      console.error('Error adding assets:', error);
      toast.error('Add Failed');
    }
  };

  const handleDelete = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.damFileId);

      const formData = new FormData();
      selectedDamFileIds.forEach((id) => formData.append('damIds_list', id));

      const response = await Axios.delete(DeleteDraftTransURL, {
        data: { FilesID: selectedDamFileIds },
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.errorStatus) {
        toast.success(response?.data?.message ?? 'Deleted Successfully');
        const remainingAssets = assets.filter((asset) => !asset.selected);
        setAssets((prev) => ({
          ...prev,
          files: assets.filter((asset) => !asset.selected),
        }));
        setAllAssetsSelected(false);
      } else {
        console.error('Error deleting assets:', response.data.message);
        toast.error('Delete Failed');
      }
    } catch (error) {
      console.error('Error deleting assets:', error);
      toast.error('Delete Failed');
    }
  };

  const selectedCount = assets.filter((asset) => asset.selected).length;
  const renderActionButtons = () => {
    if (selectedCount > 0) {
      if (location.pathname.includes('/draft')) {
        return (
          <div
            className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button mb-2"
            onClick={Addassits}
          >
            <img src={download} alt="Addassets Icon" />
            <div className="">Move to Assets</div>
          </div>
        );
      } else {
        return (
          <>
            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={collectiondataadd}
            >
              <img src={download} alt="Download Icon" />
              <div className="">Add to Collection</div>
            </div>

            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={handleDelete}
            >
              <img src={deleteicon} alt="Delete Icon" />
              <div className=""> Delete</div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={downloadImages}
            >
              <img src={download} alt="Download Icon" />
              <div className=""> Download</div>
            </div>
          </>
        );
      }
    }
    return null;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (clickedIconRef.current) {
        clickedIconRef.current = false; // reset for next click
        return; // Don't close if the icon was clicked
      }

      if (threedotIconRef.current && !threedotIconRef.current.contains(event.target)) {
        setshowbar(null);
      }
    };

    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, []);

  return (
    <>
      {modal && (
        <Deletemodel
          deletemodal={modal}
          toggledelete={() => toggle()}
          handleDelete={handledelette}
          loading={deleteLoading}
        />
      )}

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[selectedDamFieldId]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
        />
      )}

      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            color="Secondary"
            size="lg"
            click={() => setAddToCollectionModal(false)}
          />
          <ButtonC text="Save" size="lg" click={folderedit} />
        </ModalFooter>
      </Modal>
      <Modal isOpen={addcollection} toggle={collectiondataadd} style={{ width: '50%' }}>
        <ModalHeader toggle={collectiondataadd} close={closeBtn2}>
          Add to Collection
        </ModalHeader>
        <ModalBody>
          {datacollection &&
            datacollection.map((value) => {
              return (
                <p
                  className="pointer"
                  key={value.collectionID}
                  onClick={() => handleCollectionClick(value.collectionID)}
                >
                  {value.collection_name}
                </p>
              );
            })}
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}></ModalFooter>
      </Modal>

      {isLoading ? (
        <SpinnerLoader />
      ) : (
        <div className="d-flex align-items-center justify-content-between">
          <div className="mb-2">
            <p className="showingdata">Showing {assets.length} assets</p>
          </div>
          {/* <div className="d-flex align-items-center gap-2">{renderActionButtons()}</div> */}
          <div
            className="d-flex align-items-center gap-2"
            style={{
              height: '50px',
            }}
          >
            {selectedCount > 0 &&
              (location.pathname.includes('/draft') ? (
                <div className="d-flex gap-2">
                  <div
                    className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button mb-2"
                    onClick={delteMultipleDraft}
                  >
                    <img src={deleteicon} alt="Addassets Icon" />
                    <div>Delete</div>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button mb-2"
                    onClick={Addassits}
                  >
                    <img src={download} alt="Addassets Icon" />
                    <div>Move to Assets</div>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
                    onClick={collectiondataadd}
                  >
                    <img src={download} alt="Download Icon" />
                    <div>Add to Collection</div>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
                    onClick={handleDelete}
                  >
                    <img src={deleteicon} alt="Delete Icon" />
                    <div>Delete</div>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
                    onClick={downloadImages}
                  >
                    <img src={download} alt="Download Icon" />
                    <div>Download</div>
                  </div>
                </>
              ))}
          </div>
        </div>
      )}

      <div className="container-fluids">
        <div className="masonry-container">
          <Table responsive className="product-table draftAssets-table AllAssets">
            <thead>
              <tr>
                <th className="assetPreview-checkbox">
                  {!FromCollection && (
                    <span>
                      <Input
                        className="draft-checkbox"
                        type="checkbox"
                        onClick={SelectAll}
                        checked={allAssetsSelected}
                        style={{ border: '1px solid #929292' }}
                        readOnly
                      />
                    </span>
                  )}
                </th>
                <th>Preview</th>
                <th>Asset Name</th>
                <th>Asset Type</th>
                <th>Format</th>
                <th>Size</th>
                <th>Access Control</th>
                <th>Dimensions</th>
                <th>Uploaded On</th>

                <th> </th>
              </tr>
            </thead>
            <tbody>
              {assets.map((asset, index) => (
                <tr key={index}>
                  <td className="assetPreview-checkbox" style={{ width: 100 }}>
                    {!FromCollection && (
                      <span>
                        <Input
                          className="draft-checkbox"
                          type="checkbox"
                          onClick={() => selectAsset(index)}
                          checked={asset.selected}
                          readOnly
                        />
                      </span>
                    )}
                  </td>

                  <td style={{ width: 140 }}>
                    <div
                      className={`${asset.assetFormat === 'png' ? '' : ''}`}
                      style={{
                        height: '80px',
                        width: '80px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <img
                        alt="..."
                        src={asset.thumnnailUrl}
                        style={{
                          height: '100%',
                          width: '100%',
                          objectFit: 'contain',
                          cursor: 'pointer',
                        }}
                        onClick={() => onViewClickHandler(asset.assetId)}
                      />
                    </div>
                  </td>

                  <td style={{ width: 300 }}>
                    {' '}
                    <WordWrapEllipse Text={asset.assetName ? asset.assetName : 'NA'} />
                  </td>
                  <td style={{ width: 200 }}>{asset.assetType ? asset.assetType : 'NA'}</td>
                  <td style={{ width: 110 }}>{asset.assetFormat ? asset.assetFormat : 'NA'}</td>
                  <td style={{ width: 200 }}>{asset.assetSize ? asset.assetSize : 'NA'}</td>
                  <td style={{ width: 200 }}>{'NA'}</td>
                  <td style={{ width: 200 }}>
                    {asset.assetDimension ? asset.assetDimension : 'NA'}
                  </td>
                  <td style={{ width: 250 }}>
                    {' '}
                    {moment(asset?.createdOn).format('YYYY-MM-DD HH:mm:ss')}
                  </td>

                  <td style={{ width: 260, position: 'relative' }}>
                    <CommonSidePortal
                      activeId={activeId}
                      setActiveId={setActiveId}
                      portalId={index}
                      ViewSection={<CommonThreeDotSvg />}
                      OpenSection={
                        <div className="" style={{ right: '-50px', top: '70px' }}>
                          <div
                            className="d-flex align-items-center gap-2 pointer"
                            onClick={() => {
                              setSelectedDamFieldId(asset?.assetId);
                              setActiveId();
                              deletmodal();
                            }}
                          >
                            {' '}
                            <img src={deleteicon} alt="deleteicon" />{' '}
                            <p className="list_cart">Delete</p>
                          </div>

                          <div
                            className="d-flex align-items-center gap-2 pointer"
                            onClick={() => {
                              setActiveId();
                              setSelectedDamFieldId(asset?.assetId);
                              settextvalue(asset.assetName);
                              setAddToCollectionModal(!AddToCollectionModal);
                            }}
                          >
                            <img src={renameicon} alt="renameicon" />
                            <p className="list_cart">Rename</p>
                          </div>

                          {show && (
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                dispatch(
                                  setOpenPopup({ asset, id: asset?.assetId, assetType: 'file' }),
                                );
                              }}
                            >
                              {' '}
                              {DAM_SVG.permissionSvg}
                              <p className="list_cart">Invite Outside Org.</p>
                            </div>
                          )}
                          {show ? (
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => collectiondataadd(asset.assetId)}
                            >
                              {' '}
                              <img src={addcomponent} alt="coomponenticon" />{' '}
                              <p className="list_cart">Add to Collection</p>
                            </div>
                          ) : (
                            ''
                          )}
                          {show && (
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => downloadImages(asset?.assetId)}
                            >
                              {' '}
                              <img src={download} alt="componenticon" />{' '}
                              <p className="list_cart">Download</p>
                            </div>
                          )}

                          {show && (
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => Copylink(asset.assetId)}
                            >
                              {' '}
                              <img src={copyurlicon} alt="componenticon" />{' '}
                              <p className="list_cart">Copy Link</p>
                            </div>
                          )}

                          {show && (
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => handleshowdata(asset.assetId, 0)}
                            >
                              {' '}
                              <img src={shareicon} alt="componenticon" />{' '}
                              <p className="list_cart">Share</p>
                            </div>
                          )}
                          {shareshow ? (
                            <>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => handleshowdata(asset.assetId, 0)}
                              >
                                {' '}
                                <img src={shareicon} alt="componenticon" />{' '}
                                <p className="list_cart">Public Link</p>
                              </div>

                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => handleshowdata(asset.assetId, 1)}
                              >
                                {' '}
                                <img src={shareicon} alt="componenticon" />{' '}
                                <p className="list_cart">Private Link</p>
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                      }
                      Top={'15px'}
                      Right={'170px'}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default Tabledata;
